// API Configuration
// Use the same environment variable as other services
const API_BASE_URL = process.env.REACT_APP_API_URL || "https://core.gamura.ai";

export const API_ENDPOINTS = {
	// Subscription endpoints
	PLANS: `${API_BASE_URL}/api/v1/subscriptions/plans`,
	SUBSCRIBE: `${API_BASE_URL}/api/v1/subscriptions/subscribe`,
	MY_SUBSCRIPTIONS: `${API_BASE_URL}/api/v1/subscriptions/my-subscriptions`,
	MY_PAYMENTS: `${API_BASE_URL}/api/v1/subscriptions/my-payments`,
	CANCEL_SUBSCRIPTION: (id: string) =>
		`${API_BASE_URL}/api/v1/subscriptions/cancel/${id}`,
	PAUSE_SUBSCRIPTION: (id: string) =>
		`${API_BASE_URL}/api/v1/subscriptions/pause/${id}`,
	RESUME_SUBSCRIPTION: (id: string) =>
		`${API_BASE_URL}/api/v1/subscriptions/resume/${id}`,
	CHANGE_PLAN: (id: string, newPlanId: string) =>
		`${API_BASE_URL}/api/v1/subscriptions/change-plan/${id}?new_plan_id=${newPlanId}`,

	// Other endpoints can be added here
	AUTH: {
		LOGIN: `${API_BASE_URL}/api/v1/auth/login`,
		REGISTER: `${API_BASE_URL}/api/v1/auth/register`,
		REFRESH: `${API_BASE_URL}/api/v1/auth/refresh`,
	},

	// Search endpoints
	SEARCH: `${API_BASE_URL}/api/v1/search`,

	// Profile endpoints
	PROFILE: `${API_BASE_URL}/api/v1/profile`,

	// Organization endpoints
	ORGANIZATIONS: `${API_BASE_URL}/api/v1/organizations`,
};

export default API_ENDPOINTS;
